export const MASTER_COPY_ADDRESS = "0xE51abdf814f8854941b9Fe8e3A4F65CAB4e7A4a8";
export const FALLBACK_HANDLER_ADDRESS = "0xe16bA5bF81E5BB113e4752E4fdC20351d796fB24";
export const SAFE_PROXY_FACTORY = "0xaacFeEa03eb1561C4e67d661e40682Bd20E3541b";
export const MULTISEND_ADDRESS = "0xA238CBeb142c10Ef7Ad8442C6D1f9E89e07e7761";
// First element belongs to latest release. Do not alter this order. New releases go first.
const masterCopyAddressVersions = [
    {
        version: "1.3.0",
        address: MASTER_COPY_ADDRESS,
    },
];
const networksConfig = {
    masterCopyAddressVersions,
    proxyFactoryAddress: SAFE_PROXY_FACTORY,
    multiSendAddress: MULTISEND_ADDRESS,
    fallbackHandlerAddress: FALLBACK_HANDLER_ADDRESS,
};
export const defaultNetworks = {
    1: networksConfig,
    5: networksConfig,
    137: networksConfig,
    80001: networksConfig,
};
export function normalizeNetworksConfig(defaultNetworks, networks) {
    if (!networks) {
        return defaultNetworks;
    }
    const normalizedNetworks = {};
    for (const networkId of Object.keys(networks)) {
        const currentNetwork = networks[networkId];
        let mcVersions = [];
        if (currentNetwork.masterCopyAddress) {
            mcVersions = [
                {
                    version: masterCopyAddressVersions[0].version,
                    address: currentNetwork.masterCopyAddress,
                },
            ];
        }
        else if (currentNetwork.masterCopyAddressVersions) {
            mcVersions = currentNetwork.masterCopyAddressVersions;
        }
        if (mcVersions.length === 0) {
            throw new Error('Properties "masterCopyAddress" or "masterCopyAddressVersions" are missing in CPK network configuration');
        }
        normalizedNetworks[networkId] = {
            masterCopyAddressVersions: mcVersions,
            proxyFactoryAddress: currentNetwork.proxyFactoryAddress,
            multiSendAddress: currentNetwork.multiSendAddress,
            fallbackHandlerAddress: currentNetwork.fallbackHandlerAddress,
        };
    }
    return Object.assign(Object.assign({}, defaultNetworks), normalizedNetworks);
}
